import { render, staticRenderFns } from "./LoanProductsForm.vue?vue&type=template&id=9f67048e&scoped=true&"
import script from "./LoanProductsForm.vue?vue&type=script&lang=js&"
export * from "./LoanProductsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f67048e",
  null
  
)

export default component.exports